<mat-card-title>
	Service Report
	<help-text-btn class="align-help-text-btn" [helpTextId]="'ServiceReport_Overview'"></help-text-btn>
</mat-card-title>
<p style="line-height:0px;">&nbsp;</p>
<mat-divider> </mat-divider><br>

<div>
	<mat-card>
		<div class="row">
			<div class="col-lg-6">
				<mat-card-header>
					<mat-card-title>
						Search Criteria
					</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<region-dropdown-two-way [isMultiple]="true" [allowAllRegions]="false"
						[(selectedRegions)]="chosenRegions" [reset]="resetField" [required]="true" #appRegionCode>
					</region-dropdown-two-way>

					<county-dropdown-two-way [isMultiple]="true" [(selectedCounties)]="chosenCounties"
						[reset]="resetField" [required]="false" #appCountyCode [regions]="chosenRegions">
					</county-dropdown-two-way>

					<district-dropdown-two-way [isMultiple]="true" [(selectedSchoolDistricts)]="chosenSchoolDistricts"
						[reset]="resetField" [required]="false" #appSchoolDistrictCode [regions]="chosenRegions"
						[counties]="chosenCounties">
					</district-dropdown-two-way>

					<school-dropdown-two-way [isMultiple]="true" [(selectedSchools)]="chosenSchools"
						[reset]="resetField" #appSchoolsCode [regions]="chosenRegions" [counties]="chosenCounties"
						[schoolDistricts]="chosenSchoolDistricts">
					</school-dropdown-two-way>

					<app-school-year [yearType]="'PerformancePeriod'"
						(performancePeriodEvent)="performancePeriodEvent($event)" [reset]="resetField"
						[required]="true">
					</app-school-year>
				</mat-card-content>
			</div>
			<div class="col-lg-6">
				<mat-card-header>
					<mat-card-title>
						Filters
					</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<div class="row">
						<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="expiredEligibility">
							Include children without Eligibility in Period (EiP)</mat-checkbox>
						<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="expiredQAD">
							Include children with expired QAD</mat-checkbox>
						<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="emptyActiveServices">
							Include active services without children</mat-checkbox>
					</div>
					<div class="row">
						<grade-dropdown [(chosenGrades)]="grades" (gradeEvent)="gradeEventEmitter($event)"
							[isMultiple]="true" [reset]="resetField">
						</grade-dropdown>
					</div>
					<div class="row">
						<service-dropdown (serviceEvent)="serviceEventEmitter($event)" [isMultiple]="true"
							[region]="chosenRegions[0]" [reset]="resetField">
						</service-dropdown>
					</div>
					<div class="row">
						<service-period-dropdown (servicePeriodEvent)="servicePeriodEventEmitter($event)"
							[isMultiple]="true" [reset]="resetField">
						</service-period-dropdown>
					</div>
					<div class="row">
						<service-category-dropdown (serviceCategoryEvent)="serviceCategoryEventEmitter($event)"
							[isMultiple]="true" [reset]="resetField">
						</service-category-dropdown>
					</div>
				</mat-card-content>
			</div>
		</div>
		<mat-card-actions>
			<button mat-raised-button color="primary" mat-button [disabled]="!this.checkValid() || isLoading"
				(click)="search()" class="margin-right-xs">
				<mat-icon *ngIf="isLoading">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Search
			</button>
			<button mat-raised-button color="accent" (click)="reset()" mat-button class="margin-right-xs">Reset</button>

			<button [disabled]="!(results.length > 0) || isExporting" mat-raised-button [matMenuTriggerFor]="menu"
				class="margin-right-xs">
				<mat-icon *ngIf="isExporting">
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Export
				<mat-icon *ngIf="!isExporting">more_vert</mat-icon>
			</button>
			<mat-menu #menu="matMenu">
				<button mat-menu-item (click)="downloadExcel('SingleSheet')">
					<span>
						<i class="fa fa-file-excel-o margin-horizontal-md green excel-icon"></i>
						Export to Excel - Single Sheet</span>
				</button>
				<button mat-menu-item (click)="downloadExcel('SeparatedSheets')">
					<span>
						<i class="fa fa-file-excel-o margin-horizontal-md green excel-icon"></i>
						Export to Excel - Service Code</span>
				</button>
			</mat-menu>
		</mat-card-actions>
	</mat-card>
</div>

<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>

<div *ngIf="results.length > 0" class="margin-top-md">
	<div class="h5">
		Service Report - {{results.length}} {{displayName}} {{'(' + currentPerformancePeriod + ')'}}

		<button class="pull-right" mat-button [matMenuTriggerFor]="tableControlMenu">
			<mat-icon>menu</mat-icon>
		</button>

		<mat-menu #tableControlMenu="matMenu">
			<button mat-menu-item (click)="expandAll(results)">
				<span>
					Expand All
				</span>
			</button>
			<button mat-menu-item (click)="collapseAll(results)">
				<span>
					Collapse All
				</span>
			</button>
		</mat-menu>

	</div>
	<hr />
	<div *ngFor="let cur of results; let i = index" class="margin-top-sm">
		<div class="table-responsive">
			<h3>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.CODE ? '(' + cur.CODE + ')' :
					''}} {{cur.NAME}}</span>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.COUNTY_NAME}}</span>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.DISTRICTS}}</span>
				<span class="cursor-pointer" (click)="toggleShow(cur)">{{cur.SCHOOL_NAME}}</span>

				<span class="cursor-pointer" (click)="toggleShow(cur)"> {{'(' + cur.PARTY_SERVICE_COUNTS!.length +
					')'}}</span>

				<i class="fa fa-file-excel-o margin-left-lg green excel-icon"
					[ngClass]="{ 'disabled': isExporting, 'cursor-pointer': !isExporting  }"
					[matMenuTriggerFor]="isExportingIndividual === i ? null : menu" #menuTrigger="matMenuTrigger"></i>
				<mat-menu #menu="matMenu">
					<button mat-menu-item
						(click)="downloadExcel('SingleSheet', cur, cur.CODE ? 'Region ' + cur.CODE : (cur.COUNTY_NAME ? cur.COUNTY_NAME : (cur.DISTRICTS ? cur.DISTRICTS : (cur.SCHOOL_NAME? cur.SCHOOL_NAME : ''))), tableDataSources[i].data, i)">
						<span>
							<i class="fa fa-file-excel-o margin-horizontal-md green excel-icon"></i>
							Export to Excel - Single Sheet</span>
					</button>
					<button mat-menu-item
						(click)="downloadExcel('SeparatedSheets', cur, cur.CODE ? 'Region ' + cur.CODE : (cur.COUNTY_NAME ? cur.COUNTY_NAME : (cur.DISTRICTS ? cur.DISTRICTS : (cur.SCHOOL_NAME? cur.SCHOOL_NAME : ''))), tableDataSources[i].data, i)">
						<span>
							<i class="fa fa-file-excel-o margin-horizontal-md green excel-icon"></i>
							Export to Excel - Service Code</span>
					</button>
				</mat-menu>

			</h3>

			<mat-table [dataSource]="tableDataSources[i]" class="mat-elevation-z1" matSort
				(matSortChange)="announceSortChange($event)" [hidden]="!cur.SHOW">
				<ng-container matColumnDef="SERVICE_CODE">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Local Code Number </mat-header-cell>

					<mat-cell *matCellDef="let element" class="cursor-pointer" (click)="openDialog(element)">
						{{element.SERVICE_CODE}}
					</mat-cell>


				</ng-container>

				<ng-container matColumnDef="FEDERAL_CATEGORY">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Federal Category </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.FEDERAL_CATEGORY}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="FEDERAL_CATEGORY_CHILD">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Federal Sub Category </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.FEDERAL_CATEGORY_CHILD}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="SERVICE_CATEGORY">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Service Category </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SERVICE_CATEGORY}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="PARTY_SERVICE_STATUS_TYPES_ID">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Active Today </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<mat-icon>
							{{element.PARTY_SERVICE_STATUS_TYPES_ID === 1 ? 'check_box' : 'check_box_outline_blank'}}
						</mat-icon>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="SERVICE_NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Service Name </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SERVICE_NAME}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="MPO">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Measurable Program Objective </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.MPO}}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="SSDP_COMPONENTS[0].NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> SDP Components </mat-header-cell>
					<mat-cell *matCellDef="let element" class="row">
						<div *ngFor="let ssdpComponent of element.SSDP_COMPONENTS">
							{{ssdpComponent.NAME}}</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="SERVICE_HOURS.NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Service Hours </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.SERVICE_HOURS && element.SERVICE_HOURS.NAME ?
						element.SERVICE_HOURS.NAME: 'No'}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="COUNT">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Count of child(ren) served </mat-header-cell>
					<mat-cell *matCellDef="let element" [ngClass]="{'cursor-pointer': element.COUNT > 0}"
						(click)="element.COUNT > 0 ? openStudentDialog(element, cur) : null">
						<mat-icon>open_in_new</mat-icon> &nbsp; {{element.COUNT ? element.COUNT : 0}}
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
			</mat-table>
		</div>
		<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
			aria-label="Select page of periodic elements" [hidden]="!cur.SHOW">
		</mat-paginator>
	</div>
</div>